import React, { useRef } from 'react';
import { css } from '@emotion/react';
import composeRefs from '@seznam/compose-react-refs';
import { motion } from 'motion/react';
import { useScrollShadow } from '../../hooks/use-scroll-shadow';
import { CarouselArrow } from './atoms/carousel-arrow';
import { CarouselBar } from './atoms/carousel-bar';
import { useActiveSlide } from './carousel.provider';
import { CarouselProps } from './types';
import { handleButtonScroll } from './utils';

export const CarouselList: React.FC<CarouselProps> = (props) => {
  const { hideNav, children, trackingId, ...rest } = props;
  const { scrollRef, isLeft, isRight, isScrollable } = useScrollShadow();
  const CarouselListRef = useRef<HTMLDivElement | null>(null);
  const { activeSlide, uniqueId } = useActiveSlide();

  return (
    <motion.div
      layout
      layoutRoot
      css={css`
        display: flex;
        position: relative;
        width: 100%;
      `}
    >
      {!hideNav && (
        <CarouselArrow
          direction='left'
          show={isScrollable && isRight}
          trackingId={`${trackingId}-left-click`}
          onClick={() => handleButtonScroll('left', CarouselListRef.current)}
        />
      )}
      <CarouselBar
        {...rest}
        isScrollable={isScrollable}
        ref={composeRefs(scrollRef, CarouselListRef)}
        activeSlide={activeSlide}
        uniqueId={uniqueId}
      >
        {children as Array<JSX.Element>}
      </CarouselBar>
      {!hideNav && (
        <CarouselArrow
          direction='right'
          trackingId={`${trackingId}-right-click`}
          show={isScrollable && isLeft}
          onClick={() => handleButtonScroll('right', CarouselListRef.current)}
        />
      )}
    </motion.div>
  );
};
